var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"q-app-bar-btn",class:_vm.btnClass,attrs:{"depressed":"","ripple":false},on:{"click":_vm.showSearch}},[_c('v-icon',[_vm._v("icon-q-search")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }